module.exports = __webpack_public_path__ + "img/file-image-purple.df5b413c.svg";